/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
// @ts-nocheck
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useAccount } from 'wagmi';
import { useHistory, useLocation } from 'react-router-dom'; // Import useLocation
import '../App.css';
import '../styles/MainContainer.css';
import TopBar from '../components/TopBar.jsx';
import KycModal from '../components/KYCModal.tsx';
import UsernameModal from './UsernameModal.tsx';
import ProfilePictureModal from './ProfilePictureModal.tsx';
import ContactListModal from './ContactListModal.tsx';
import ProfileHeader from '../components/ProfileHeader.tsx';
import ProfileTabs from '../components/ProfileTabs.tsx';
import StreamConfigModal from './StreamConfigModal.tsx'; // Import the new modal
import PrivateStreamPaymentModal from './PrivateStreamPaymentModal.tsx'; // Add this import
import { StringParam, useQueryParam } from 'use-query-params';
import { apiUrl, supportedChainIds, chainLogos, imageUrl, projectName, coinNames, scanLinks, initialEth1 } from '../utils/constants.ts'; // Add ethPriceApiUrl
import { ethPriceApiUrl } from '../utils/priceApi.ts';

import { getMulticallAddress } from '../utils/addressHelpers.ts'; // Add getMulticallAddress
import { config } from '../config.jsx'; // Add config import
import CopyIcon from '../icons/copy.svg';
import { readContract } from '@wagmi/core'; // <-- Add readContract
import { formatUnits, erc20Abi, parseUnits } from 'viem'; // <-- Import parseUnits
import MultiCallAbi from '../config/MultiCallAbi.json';
import * as chatService from '../services/chatService.ts'; 
import { getUnreadMessageCount, markMessagesAsRead, Message, fetchPrivateStreams, getInternalWalletBalance, PrivateStreamInfo, InternalWalletInfo, withdrawFromInternalWallet } from '../services/chatService.ts';
import UserProfileModal from '../components/UserProfileModal.tsx';
import ChatModal from '../components/ChatModal.tsx'; 
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useQuery } from '@tanstack/react-query'; // Import useQuery from @tanstack/react-query
import axios from 'axios'; // Asegúrate de tener axios instalado
import { AppNotification, UserProfile, Contact, PendingRequest, DeployedTokenData, TradeHistoryEntry, TokenBalanceData } from '../types.tsx';
import {
    fetchProfileData,
    fetchContacts,
    addContact,
    removeContact,
    getAllUsersForSuggestions,
    ensureInternalWallet,
    setUsername,
    setProfilePicture,
    fetchWithdrawalHistory, // <-- Importar la nueva función
    WithdrawalRecord, // <-- Importar el tipo
    PaginatedWithdrawalHistory // <-- Importar el tipo
} from '../services/profileService.ts';

import InternalWalletCard from '../components/InternalWalletCard.tsx';
import PrivateStreamCard from '../components/PrivateStreamCard.tsx';

import { 
  getStreamStartTime, 
  shouldStreamStart, 
  formatTimeRemaining,
  isStreamHost,
  isStreamGuest,
  getOtherParty,
  processStreamForDisplay,
  isPendingStream,
  isPaidStream,
  isActiveStream
} from '../utils/streamUtils.ts';

// --- Define Minimal Bonding Curve ABI Fragment ---
const bondingCurveAbiFragment = [
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenAmountToBuy", // Input amount of tokens to query price for
        "type": "uint256"
      }
    ],
    "name": "getBuyPrice", // Common function name, might need adjustment
    "outputs": [
      {
        "internalType": "uint256",
        "name": "ethCost", // Output: Cost in ETH (wei)
        "type": "uint256"
      }
      // Some contracts might return multiple values (e.g., cost and fee)
      // If so, adjust the outputs array and how you access the result
    ],
    "stateMutability": "view",
    "type": "function"
  }
] as const; // Use 'as const' for better type inference with Viem/Wagmi
// --- End ABI Fragment ---

// --- Define Formatted Balance Type ---
interface FormattedTokenBalanceData extends Omit<TokenBalanceData, 'balance'> {
    formattedBalance: string; // Balance formatted as a string
}
// --- End Formatted Balance Type ---


const Profile: React.FC<ProfileProps> = ({
    notifications,
    unreadNotificationCount,
    onNotificationClick,
    onClearAllNotifications,
    onMarkNotificationsRead, // Receive the new handler
    lastMessage, // Receive lastMessage
    // ... other potential global props
    isWsConnected,
    sendWsMessage,
}) => {
    // --- ADD LOG INSIDE COMPONENT FUNCTION SCOPE ---
    // console.log('[Profile Component Render] typeof fetchContacts:', typeof fetchContacts); // Commented out: Internal detail
    // --- END ADD LOG ---

    // --- FIX: Move hook calls before usage in logs ---
    let [profileAddressParam] = useQueryParam('address', StringParam);
    const { address: connectedAddress } = useAccount();
    const historyHook = useHistory();
    const location = useLocation<{ senderAddressToOpenChat?: string }>(); // Get location object
    // --- END FIX ---

    // --- ADD isMounted Ref ---
    const isMounted = useRef(true);
    // --- END ADD ---

    // --- ADD LOG: Component Render Start ---
    // console.log(`[Profile] Rendering component. profileAddressParam=${profileAddressParam}, connectedAddress=${connectedAddress}`); // Commented out: General render log
    // --- END LOG ---

    const profileAddress = profileAddressParam && profileAddressParam !== "undefined" ? profileAddressParam : connectedAddress;

    // --- ADD LOG: Effective Profile Address ---
    // console.log(`[Profile] Effective profileAddress to fetch: ${profileAddress}`); // Commented out: Internal detail
    // --- END LOG ---

    // --- REORGANIZE STATE DECLARATIONS: Move all state declarations to the top ---
    // Profile related states
    const [profileData, setProfileData] = useState<UserProfile | null>(null);
    const [isProfileLoading, setIsProfileLoading] = useState(true);

    // Contact related states
    const [contacts, setContacts] = useState<Contact[]>([]);
    const [isContactListLoading, setIsContactListLoading] = useState(true);
    const [isContactActionLoading, setIsContactActionLoading] = useState(false);

    // Tabs and data states
    const [selectedOption, setSelectedOption] = useState('Balances');
    const [funLists, setFunListData] = useState([]);
    const [funBalances, setFunBalances] = useState<TokenBalanceData[]>([]); // Original state with numbers
    const [history, setHistory] = useState([{ amount: 0, name: '', token: '', type: '', date: '' }]);
    const [tradeHistory, setTradeHistory] = useState([{ amount: 0, name: '', token: '', type: '', date: '' }]);
    const [funBalanceData, setFunBalanceData] = useState<TokenBalanceData[]>([]); // ADD THIS LINE

    // Loading and fetched states
    const [loading, setLoading] = useState(false); // Single loading state
    const [fetched, setFetched] = useState(false); // Fetched flag for Deploys
    const [fetched1, setFetched1] = useState(false); // Fetched flag for Balances
    const [isLoadingWallet, setIsLoadingWallet] = useState(false);

    // Pagination states
    const [currentTransactionPage, setCurrentTransactionPage] = useState(1);
    const [transactionTotalPages, setTransactionTotalPages] = useState(0);
    const transactionItemsPerPage = 5;

    // Modal states
    const [isKycModalOpen, setIsKycModalOpen] = useState(false);
    const [selectedToken, setSelectedToken] = useState(null);
    const [isUsernameModalOpen, setIsUsernameModalOpen] = useState(false);
    const [isPictureModalOpen, setIsPictureModalOpen] = useState(false);
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
    const [isUserProfileModalOpen, setIsUserProfileModalOpen] = useState(false);
    const [selectedUserProfile, setSelectedUserProfile] = useState<UserProfile | null>(null);
    const [isChatModalOpen, setIsChatModalOpen] = useState(false);
    const [chatTargetUser, setChatTargetUser] = useState<UserProfile | Contact | null>(null);
    const [isStreamConfigModalOpen, setIsStreamConfigModalOpen] = useState(false); // State for the new modal
    const [streamConfigLoading, setStreamConfigLoading] = useState(false); // Loading state for config submission

    // Wallet and stream states
    const [internalWallet, setInternalWallet] = useState<InternalWalletInfo | null>(null);
    const [privateStreams, setPrivateStreams] = useState<PrivateStreamInfo[]>([]);
    const [withdrawAmount, setWithdrawAmount] = useState('');
    const [isWithdrawModalOpen, setIsWithdrawModalOpen] = useState(false);
    const [isProcessingWithdrawal, setIsProcessingWithdrawal] = useState(false);
    const [withdrawError, setWithdrawError] = useState('');
    const [walletInfo, setWalletInfo] = useState<any>(null);

    // --- NEW: State for Withdrawal History ---
    const [withdrawalHistory, setWithdrawalHistory] = useState<WithdrawalRecord[]>([]);
    const [withdrawalHistoryPagination, setWithdrawalHistoryPagination] = useState<PaginatedWithdrawalHistory['pagination'] | null>(null);
    const [isLoadingWithdrawalHistory, setIsLoadingWithdrawalHistory] = useState(false);
    const [currentWithdrawalHistoryPage, setCurrentWithdrawalHistoryPage] = useState(1);
    // --- END NEW ---

    // Payment and Stream states
    const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
    const [selectedStream, setSelectedStream] = useState<any>(null);

    // Message states
    const [unreadCounts, setUnreadCounts] = useState<Record<string, number>>({});
    // --- END REORGANIZE ---

    // --- Modificar la determinación de isOwnProfile para ser más robusta ---
    // Versión original:
    // const isOwnProfile = connectedAddress && profileAddress && connectedAddress.toLowerCase() === profileAddress.toLowerCase();

    // Nueva versión mejorada con verificación adicional:
    const isOwnProfile = useMemo(() => {
        console.log(`[Profile] Verificando isOwnProfile: connectedAddress=${connectedAddress}, profileAddress=${profileAddress}, profileAddressParam=${profileAddressParam}`);
        
        // Si no hay profileAddressParam específico (o es undefined), asumimos que es el perfil propio
        if (!profileAddressParam || profileAddressParam === "undefined") {
            console.log('[Profile] No hay profileAddressParam específico, asumiendo perfil propio');
            return true;
        }
        
        // Comparación estándar de direcciones
        const result = connectedAddress && profileAddress && 
                    connectedAddress.toLowerCase() === profileAddress.toLowerCase();
        
        console.log(`[Profile] Resultado de isOwnProfile: ${result}`);
        return result;
    }, [connectedAddress, profileAddress, profileAddressParam]);

    // --- FIX: Ensure profileAddress is checked before toLowerCase ---
    const isAlreadyContact = contacts.some(c => profileAddress && c.walletAddress.toLowerCase() === profileAddress.toLowerCase());
    // --- END FIX ---

    // --- REMOVE Lifted Notification State ---
    // const [notifications, setNotifications] = useState<AppNotification[]>([]);
    // const unreadNotificationCount = useMemo(() => { ... }, [notifications]);
    // --- END REMOVE ---

    // Keep totalUnreadCount for contact list badges
    const totalUnreadCount = useMemo(() => {
        return Object.values(unreadCounts).reduce((sum, count) => sum + count, 0);
    }, [unreadCounts]);

    // --- REMOVE useWebSocket hook call ---
    // const { lastMessage, isConnected, sendMessage: sendWsMessage } = useWebSocket(connectedAddress);
    // --- END REMOVE ---

    // --- NEW: Memoized Formatted Balances ---
    const formattedFunBalances = useMemo(() => {
        return funBalances.map(item => ({
            ...item,
            // Format the balance number using en-US locale (period for decimal, comma for thousands)
            // Adjust maximumFractionDigits as needed for precision
            formattedBalance: item.balance.toLocaleString('en-US', {
                minimumFractionDigits: 2, // Show at least 2 decimal places
                maximumFractionDigits: 8  // Show up to 8 decimal places
            })
        }));
    }, [funBalances]); // Re-calculate only when funBalances changes
    // --- END NEW ---

    // --- Main Data Fetching useEffect (Original Structure) ---
    useEffect(() => {
        // --- Define Fetch Functions INSIDE useEffect ---
        const FetchDeployedData = async () => {
            // --- LOG: Start FetchDeployedData ---
            // console.log(`\n\n[🚀 DEPLOYS] ===== START FetchDeployedData for ${profileAddress} =====`); // Commented out: Data fetching log
            // --- END LOG ---
            try {
                setLoading(true)
                // Clear previous data before fetching new data for deploys
                setFunListData([]); // Add this line to clear previous deploys

                for (const chainId of supportedChainIds) {
                    // --- LOG: Start Chain Iteration ---
                    // console.log(`[🚀 DEPLOYS] --- Processing Chain ID: ${chainId} ---`); // Commented out: Data fetching log
                    // --- END LOG ---
                    let ethPrice = 0; // Default price if fetch fails
                    try {
                        // --- FIX: Call the function from priceApi.ts ---
                        const priceFunction = ethPriceApiUrl[chainId];
                        if (typeof priceFunction !== 'function') {
                            // console.error(`[❌ PRICE_ERROR] No price function defined for chainId ${chainId} in priceApi.ts`); // Commented out: Data fetching error
                            continue; // Skip this chain if no function is defined
                        }
                        // --- LOG: Calling Price Function ---
                        // console.log(`[💰 PRICE] Calling price function for chain ${chainId}...`); // Commented out: Data fetching log
                        // --- END LOG ---
                        ethPrice = await priceFunction(); // Call the async function
                        // --- LOG: Extracted ETH Price ---
                        // console.log(`[💰 PRICE] Extracted ETH Price for chain ${chainId}: ${ethPrice}`); // Commented out: Data fetching log
                        // --- END LOG ---
                        if (typeof ethPrice !== 'number' || isNaN(ethPrice)) {
                             // console.error(`[❌ PRICE_ERROR] Invalid price received for chainId ${chainId}:`, ethPrice); // Commented out: Data fetching error
                             ethPrice = 0; // Reset to default if invalid
                             continue; // Optionally skip chain if price is crucial and invalid
                        }
                        // --- END FIX ---
                    } catch (priceError) { // Catch errors specifically from the price function call
                        // console.error(`[❌ PRICE_ERROR] Failed to get price for chainId ${chainId}:`, priceError); // Commented out: Data fetching error
                        // Decide if you want to continue without price or skip the chain
                        // For now, we continue with ethPrice = 0
                         continue; // Skip this chain if price fetching fails
                    }

                    const multicallAddr = getMulticallAddress(chainId);
                    // --- LOG: Calling getUserDeployMainInfo ---
                    // console.log(`[🚀 DEPLOYS] Calling readContract: getUserDeployMainInfo(${profileAddress}) on chain ${chainId} via ${multicallAddr}`); // Commented out: Data fetching log
                    // --- END LOG ---
                    let mainInfo = await readContract(config, {
                        address: multicallAddr,
                        abi: MultiCallAbi,
                        functionName: 'getUserDeployMainInfo',
                        args: [profileAddress],
                        chainId: chainId
                    })
                    // --- LOG: Received getUserDeployMainInfo ---
                    // console.log(`[🚀 DEPLOYS] Received from getUserDeployMainInfo:`, mainInfo); // Commented out: Data fetching log
                    // --- END LOG ---

                    // --- LOG: Calling getUserDeployOtherInfo ---
                    // console.log(`[🚀 DEPLOYS] Calling readContract: getUserDeployOtherInfo(${profileAddress}) on chain ${chainId} via ${multicallAddr}`); // Commented out: Data fetching log
                    // --- END LOG ---
                    let otherInfo = await readContract(config, {
                        address: multicallAddr,
                        abi: MultiCallAbi,
                        functionName: 'getUserDeployOtherInfo',
                        args: [profileAddress],
                        chainId: chainId
                    })
                    // --- LOG: Received getUserDeployOtherInfo ---
                    // console.log(`[🚀 DEPLOYS] Received from getUserDeployOtherInfo:`, otherInfo); // Commented out: Data fetching log
                    // --- END LOG ---

                    // --- LOG: Calling getRestInfo ---
                    // console.log(`[🚀 DEPLOYS] Calling readContract: getRestInfo() on chain ${chainId} via ${multicallAddr}`); // Commented out: Data fetching log
                    // --- END LOG ---
                    const restInfo = await readContract(config, {
                        address: multicallAddr,
                        abi: MultiCallAbi,
                        functionName: 'getRestInfo',
                        chainId: chainId
                    })
                    // --- LOG: Received getRestInfo ---
                    // console.log(`[🚀 DEPLOYS] Received from getRestInfo:`, restInfo); // Commented out: Data fetching log
                    // --- END LOG ---

                    // --- LOG: Calling getTokenAddress ---
                    // console.log(`[🚀 DEPLOYS] Calling readContract: getTokenAddress(${profileAddress}) on chain ${chainId} via ${multicallAddr}`); // Commented out: Data fetching log
                    // --- END LOG ---
                    let tokenInfo = await readContract(config, {
                        address: multicallAddr,
                        abi: MultiCallAbi,
                        functionName: 'getTokenAddress',
                        args: [profileAddress],
                        chainId: chainId
                    })
                    // --- LOG: Received getTokenAddress ---
                    // console.log(`[🚀 DEPLOYS] Received from getTokenAddress:`, tokenInfo); // Commented out: Data fetching log
                    // --- END LOG ---

                    if (mainInfo && otherInfo && tokenInfo && restInfo) { // Ensure all data is available
                        // --- FIX: Add checks for sub-arrays within restInfo ---
                        // --- FIX: Also check mainInfo sub-arrays needed for old logic (mainInfo[1], mainInfo[2], mainInfo[3]) ---
                        if (mainInfo[0]?.length > 0 && mainInfo[1] && mainInfo[2] && mainInfo[3] && mainInfo[4] && mainInfo[5] && restInfo[1] && restInfo[2]) {
                        // --- END FIX ---
                            // console.log(`[🚀 DEPLOYS] Processing ${mainInfo[0].length} deployed tokens for chain ${chainId}...`); // Commented out: Data fetching log
                            for (let i = mainInfo[0].length - 1; i >= 0; i--) {
                                // Check if index exists in all arrays to prevent errors
                                // --- FIX: Adjust check for restInfo sub-arrays and mainInfo arrays ---
                                if (i < tokenInfo.length &&
                                    i < otherInfo[0]?.length && i < otherInfo[2]?.length && i < otherInfo[3]?.length && i < otherInfo[4]?.length &&
                                    i < mainInfo[1]?.length && i < mainInfo[2]?.length && i < mainInfo[3]?.length && i < mainInfo[4]?.length && i < mainInfo[5]?.length &&
                                    i < restInfo[1]?.length && i < restInfo[2]?.length) { // Added more checks for safety
                                // --- END FIX ---
                                    const contractAddress = mainInfo[4][i];
                                    const tokenAddress = tokenInfo[i];

                                    // --- REMOVE Fetch totalSupply and decimals ---
                                    // let totalSupply = 0n;
                                    // let decimals = 18; // Default decimals
                                    // try { ... } catch { ... }
                                    // const formattedTotalSupply = Number(formatUnits(totalSupply, decimals));
                                    // --- END REMOVE ---

                                    // --- REMOVE Try fetching price from Bonding Curve Contract ---
                                    // let tokenPriceUsd = 0;
                                    // let marketCap = 0;
                                    // let progress = 0;
                                    // let priceFetchError = false;
                                    // try { ... call getBuyPrice ... } catch { ... priceFetchError = true ... }
                                    // --- END REMOVE ---

                                    // --- START: Replicate Old Calculation Logic ---
                                    const virtualLpWei = typeof mainInfo[1][i] === 'bigint' ? mainInfo[1][i] : 0n;
                                    const virtualLpEth = Number(formatUnits(virtualLpWei, 18));
                                    const liquidity = virtualLpEth * ethPrice; // Old Liquidity calculation (Note: Old code multiplied by 2 for TVL, here we just use LP value * price)

                                    // Get the 'tokenPrice' value from mainInfo[2][i] as in the old code
                                    const tokenPriceRaw = mainInfo[2][i];
                                    const tokenPrice = typeof tokenPriceRaw === 'bigint' ? Number(tokenPriceRaw) : 0; // Convert BigInt safely

                                    // Calculate Market Cap using the old formula
                                    // marketCap = (tokenPrice * 1000000000 * Number(ethPrice)) / 10 ** 12
                                    // Ensure ethPrice is not 0 to avoid division issues if needed, though the formula doesn't divide by it directly.
                                    // Handle potential large numbers safely.
                                    let marketCap = 0;
                                    if (ethPrice > 0) {
                                        // Use BigInt for intermediate calculation if numbers can get very large
                                        try {
                                            const priceBigInt = BigInt(tokenPrice); // Assumes tokenPrice is integer-like after conversion
                                            const ethPriceBigInt = BigInt(Math.floor(ethPrice * 1e18)); // Convert ETH price to wei-like BigInt
                                            const numerator = priceBigInt * 1000000000n * ethPriceBigInt; // (tokenPrice * 1e9 * ethPriceWei)
                                            const denominator = 10n ** 12n * 10n ** 18n; // (1e12 * 1e18) - Adjust denominator based on tokenPrice and ethPrice units
                                            marketCap = Number(numerator / denominator); // Convert final result back to Number
                                            // --- LOG: Old MCAP Calculation ---
                                            // console.log(`[🚀 DEPLOYS][${i}] MCAP (Old Formula): (tokenPrice (${tokenPrice}) * 1e9 * ethPrice (${ethPrice})) / 1e12 = marketCap (${marketCap})`); // Commented out: Data calculation log
                                            // console.log(`   (Using mainInfo[2][${i}]=${tokenPriceRaw})`); // Commented out: Data calculation log
                                            // --- END LOG ---
                                        } catch (calcError) {
                                            // console.error(`[❌ CALC_ERROR][${i}] Error calculating old market cap formula:`, calcError); // Commented out: Data calculation error
                                            marketCap = 0; // Set to 0 on calculation error
                                        }
                                    } else {
                                        // console.warn(`[⚠️ CALC_WARN][${i}] ETH price is 0, cannot calculate market cap using old formula.`); // Commented out: Data calculation warning
                                        marketCap = 0;
                                    }


                                    // Calculate Progress using the old formula
                                    const progress = marketCap > 0 && marketCap < 69000 ? (marketCap * 100 / 69000) : (marketCap >= 69000 ? 100 : 0);

                                    // Calculate Volume (Deposited Amount) using the old formula
                                    const depositedWei = typeof mainInfo[3][i] === 'bigint' ? mainInfo[3][i] : 0n;
                                    const depositedEth = Number(formatUnits(depositedWei, 18));
                                    const volume = depositedEth * ethPrice; // Volume = Total_Deposited_ETH * ETH_Price
                                    // --- END: Replicate Old Calculation Logic ---


                                    // --- Calculations (TVL, Volume remain the same) --- - This comment is now slightly inaccurate, volume/liquidity are calculated above with old logic

                                    // --- Recalculate Progress based on potentially updated marketCap --- - This block is now redundant as progress is calculated above
                                    // if (!priceFetchError) { ... } else { ... }

                                    const website = otherInfo[2][i];
                                    const twitter = otherInfo[3][i];
                                    const telegram = otherInfo[4][i];
                                    const name = otherInfo[0][i];
                                    let logoUrl = imageUrl + 'logo/' + projectName + "-" + chainId + "-" + contractAddress + '.png';
                                    let bannerUrl = imageUrl + 'banner/' + projectName + "-" + chainId + "-" + contractAddress + '.png';
                                    let blockchainLogoUrl = chainLogos[chainId];
                                    let devAddress = mainInfo[5][i];
                                    let dexAddress = 'https://app.uniswap/swap'; // Consider making this dynamic based on chainId
                                    let dexName = 'Uniswap'; // Consider making this dynamic
                                    // --- FIX: Correctly find the description index and value ---
                                    // Find the index of the current contractAddress within the addresses array (restInfo[2])
                                    // --- FIX: Use mainInfo[4][i] (contractAddress) for lookup in restInfo[2] ---
                                    const descIndex = restInfo[2].findIndex(addr => typeof addr === 'string' && addr.toLowerCase() === mainInfo[4][i].toLowerCase());
                                    // Get the description from the descriptions array (restInfo[1]) using the found index
                                    const description = descIndex !== -1 && descIndex < restInfo[1].length ? restInfo[1][descIndex] : "No description available."; // Fallback description
                                    // --- END FIX ---

                                    const funData: DeployedTokenData = { // Added Type for clarity
                                        chainId: chainId,
                                        progress: progress, // Use progress from old formula
                                        Liquidity: liquidity, // Use liquidity from old formula
                                        tokenName: name,
                                        tokenDescription: description, // Use the correctly found description
                                        logoUrl: logoUrl,
                                        bannerUrl: bannerUrl,
                                        address: mainInfo[4][i], // Keep this as contract address
                                        depositedAmount: volume, // Use volume from old formula
                                        contractAddress: contractAddress,
                                        tokenAddress: tokenAddress,
                                        dexAddress: dexAddress,
                                        devAddress: devAddress,
                                        dexName: dexName,
                                        marketCap: marketCap, // Use marketCap from old formula
                                        website: website,
                                        twitter: twitter,
                                        telegram: telegram,
                                        blockchainLogoUrl: blockchainLogoUrl,
                                        raisingPercent: 0, // Keep default or adjust if needed
                                    };
                                    // --- LOG: Processed Deployed Token Data ---
                                    // console.log(`[🚀 DEPLOYS] Processed Deployed Token Data (Index ${i}, Chain ${chainId}):`, JSON.stringify(funData)); // Commented out: Data processing log
                                    // --- END LOG ---
                                    setFunListData(prevState => [...prevState, funData]);
                                } else {
                                     // console.warn(`[🚀 DEPLOYS] Skipping index ${i} for chain ${chainId} due to inconsistent array lengths from multicall or missing restInfo/mainInfo sub-arrays.`); // Commented out: Data processing warning
                                }
                            }
                        } else {
                            // console.log(`[🚀 DEPLOYS] No deployed tokens found for chain ${chainId} or missing required sub-arrays in multicall results.`); // Commented out: Data fetching log
                        }
                    } else {
                         // console.log(`[🚀 DEPLOYS] mainInfo, otherInfo, tokenInfo or restInfo is null/undefined for chain ${chainId}.`); // Commented out: Data fetching log
                    }
                }
                setLoading(false)
                setFetched(true)
                // --- LOG: End FetchDeployedData ---
                // console.log(`[🚀 DEPLOYS] ===== END FetchDeployedData for ${profileAddress} =====\n\n`); // Commented out: Data fetching log
                // --- END LOG ---
            } catch (e) {
                setLoading(false)
                // --- FIX: Set fetched to true even on error to prevent re-fetching loop ---
                setFetched(true);
                // --- END FIX ---
                // console.error("[❌ DEPLOYS_ERROR] Error in FetchDeployedData:", e) // Commented out: Data fetching error
                // --- LOG: Error End FetchDeployedData ---
                // console.log(`[❌ DEPLOYS_ERROR] ===== ERROR END FetchDeployedData for ${profileAddress} =====\n\n`); // Commented out: Data fetching error
                // --- END LOG ---
            }
        }

        const FetchBalances = async () => {
            // --- LOG: Start FetchBalances ---
            // console.log(`\n\n[📊 BALANCES] ===== START FetchBalances for ${profileAddress} =====`); // Commented out: Data fetching log
            // --- END LOG ---
            try {
                setLoading(true);
                setFunBalances([]); // Clear previous balances
                for (const chainId of supportedChainIds) {
                    // --- LOG: Start Chain Iteration (Balances) ---
                    // console.log(`[📊 BALANCES] --- Processing Chain ID: ${chainId} (Balances) ---`); // Commented out: Data fetching log
                    // --- END LOG ---
                    const multicallAddr = getMulticallAddress(chainId);
                    // --- LOG: Calling getUserBalance ---
                    // console.log(`[📊 BALANCES] Calling readContract: getUserBalance(${profileAddress}) on chain ${chainId} via ${multicallAddr}`); // Commented out: Data fetching log
                    // --- END LOG ---
                    let mainInfo = await readContract(config, {
                        address: multicallAddr,
                        abi: MultiCallAbi,
                        functionName: 'getUserBalance',
                        args: [profileAddress],
                        chainId: chainId
                    });
                    // --- LOG: Received getUserBalance ---
                    // console.log(`[📊 BALANCES] Received from getUserBalance:`, mainInfo); // Commented out: Data fetching log
                    // --- END LOG ---

                    if (mainInfo && mainInfo[0] && mainInfo[1] && mainInfo[2] && mainInfo[3]) { // Check all arrays exist
                        if (mainInfo[0].length > 0) {
                            // console.log(`[📊 BALANCES] Processing ${mainInfo[0].length] balances for chain ${chainId}...`); // Commented out: Data fetching log
                            for (let i = mainInfo[0].length - 1; i >= 0; i--) {
                                // Check index bounds for all relevant arrays
                                if (i < mainInfo[1].length && i < mainInfo[2].length && i < mainInfo[3].length) {
                                    const name = mainInfo[0][i];
                                    const symbol = mainInfo[1][i];
                                    const contractAddress = mainInfo[2][i];
                                    // Safely convert BigInt to Number for division
                                    const balanceRaw = mainInfo[3][i];
                                    const balance = typeof balanceRaw === 'bigint' ? Number(balanceRaw) / (10 ** 18) : 0;
                                    let logoUrl = imageUrl + 'logo/' + projectName + "-" + chainId + "-" + contractAddress + '.png';
                                    const funData: TokenBalanceData = { // Use the original type here
                                        chainId,
                                        name: name,
                                        symbol: symbol,
                                        contractAddress: contractAddress,
                                        logoUrl: logoUrl,
                                        balance: balance // Keep as number
                                    };
                                    // --- LOG: Processed Balance Data ---
                                    // console.log(`[📊 BALANCES] Processed Balance Data (Index ${i}, Chain ${chainId}):`, JSON.stringify(funData)); // Commented out: Data processing log
                                    // --- END LOG ---
                                    setFunBalances(prev => [...prev, funData]); // Use setFunBalances here
                                } else {
                                    // console.warn(`[📊 BALANCES] Skipping index ${i} for chain ${chainId} due to inconsistent array lengths from multicall.`); // Commented out: Data processing warning
                                }
                            }
                        } else {
                            // console.log(`[📊 BALANCES] No balances found for chain ${chainId}.`); // Commented out: Data fetching log
                        }
                    } else {
                        // console.log(`[📊 BALANCES] mainInfo (balances) or its sub-arrays are null/undefined for chain ${chainId}.`); // Commented out: Data fetching log
                    }
                }
                setLoading(false);
                setFetched1(true);
                // --- LOG: End FetchBalances ---
                // console.log(`[📊 BALANCES] ===== END FetchBalances for ${profileAddress} =====\n\n`); // Commented out: Data fetching log
                // --- END LOG ---
            } catch (e) {
                setLoading(false);
                // console.error("[❌ BALANCES_ERROR] Error in FetchBalances:", e); // Commented out: Data fetching error
                // --- LOG: Error End FetchBalances ---
                // console.log(`[❌ BALANCES_ERROR] ===== ERROR END FetchBalances for ${profileAddress} =====\n\n`); // Commented out: Data fetching error
                // --- END LOG ---
            }
        }

        const FetchTrades = async () => {
            // --- LOG: Start FetchTrades ---
            // console.log(`\n\n[📈 TRADES] ===== START FetchTrades for ${profileAddress} =====`); // Commented out: Data fetching log
            // --- END LOG ---
            try {
                // Reset state before fetching
                setTradeHistory([]); // Clear previous trades

                const fetchUrl = `${apiUrl}/getUserHistory/${profileAddress}`;
                // --- LOG: Fetching Trades ---
                // console.log(`[📈 TRADES] Fetching trades from: ${fetchUrl}`); // Commented out: Data fetching log
                // --- END LOG ---
                const response = await fetch( // Use await directly
                    fetchUrl,
                    {
                        method: 'GET'
                    }
                );

                // --- LOG: Trades Response Status ---
                // console.log(`[📈 TRADES] Trades Response Status: ${response.status}`); // Commented out: Data fetching log
                // --- END LOG ---

                if (!response.ok) {
                    throw new Error(`Failed to fetch trades: ${response.statusText}`);
                }

                let data = await response.json();
                // --- LOG: Trades Raw Data ---
                // console.log(`[📈 TRADES] Trades Raw Data:`, JSON.stringify(data)); // Commented out: Data fetching log
                // --- END LOG ---

                if (data && data.length > 0) {
                    // console.log(`[📈 TRADES] Processing ${data.length} trades...`); // Commented out: Data fetching log
                    let historyData: any[] = [];
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        let chainId = item.chainId;
                        let amount = item.amount;
                        let buyer = item.buyer;
                        let name = item.name;
                        let token = item.token;
                        let type = item.type;
                        let contract = item.contract;
                        let currentDate = Date.now();
                        let timestamp = currentDate / 1000 - Number(item.timestamp);
                        let date;
                        if (timestamp > 86400) {
                            date = Math.floor(timestamp / 86400) + ' days ago'; // Use Math.floor
                        } else if (timestamp > 3600) {
                            date = Math.floor(timestamp / 3600) + ' hours ago'; // Use Math.floor
                        } else if (timestamp > 60) { // Check for > 60 seconds
                            date = Math.floor(timestamp / 60) + ' mins ago'; // Use Math.floor
                        } else {
                            date = ' just now';
                        }
                        const historyEntry = { chainId, amount: amount, buyer: buyer, name: name, token: token, type: type, contract: contract, date: date };
                        // --- LOG: Processed Trade Data ---
                        // console.log(`[📈 TRADES] Processed Trade Data (Index ${i}):`, JSON.stringify(historyEntry)); // Commented out: Data processing log
                        // --- END LOG ---
                        historyData.push(historyEntry);
                    }
                    setTradeHistory(historyData); // Update state with the processed array
                } else {
                    // console.log(`[📈 TRADES] No trades found or empty data received.`); // Commented out: Data fetching log
                    setTradeHistory([]); // Ensure state is empty array if no trades
                }
                // --- LOG: End FetchTrades ---
                // console.log(`[📈 TRADES] ===== END FetchTrades for ${profileAddress} =====\n\n`); // Commented out: Data fetching log
                // --- END LOG ---
            } catch (e) {
                // console.error("[❌ TRADES_ERROR] Error in FetchTrades:", e); // Commented out: Data fetching error
                setTradeHistory([]); // Reset state on error
                // --- LOG: Error End FetchTrades ---
                // console.log(`[❌ TRADES_ERROR] ===== ERROR END FetchTrades for ${profileAddress} =====\n\n`); // Commented out: Data fetching error
                // --- END LOG ---
            }
        }
        if (profileAddress) {
            // --- LOG: useEffect Trigger ---
            // console.log(`[⚙️ EFFECT] useEffect triggered. Selected Option: ${selectedOption}, Fetched Deploys: ${fetched}, Fetched Balances: ${fetched1}`); // Commented out: Internal effect log
            // --- END LOG ---
            if (selectedOption === 'Deploys' && !fetched) {
                FetchDeployedData()
            } else if (selectedOption === 'Balances' && !fetched1) {
                FetchBalances()
            } else if (selectedOption === 'Trades') {
                FetchTrades() // Fetch trades every time the tab is selected
            }
        }
    }, [selectedOption, profileAddress, fetched, fetched1]) // Add fetched flags to dependencies to re-evaluate if needed
    // --- End Main Data Fetching useEffect ---

    // --- Profile Data Fetching Effect (Keep as is, but reset original flags) ---
    useEffect(() => {
        isMounted.current = true;
        // console.log(`[Profile] Main profile data fetching useEffect triggered. profileAddress=${profileAddress}`); // Already logged elsewhere
        if (profileAddress) {
            setIsProfileLoading(true);
            // --- LOG: Fetching Profile Data ---
            // console.log(`[👤 PROFILE] Fetching profile data for ${profileAddress}...`); // Commented out: Data fetching log
            // --- END LOG ---
            fetchProfileData(profileAddress)
                .then(data => {
                    // --- LOG: Received Profile Data ---
                    // console.log(`[👤 PROFILE] Received profile data for ${profileAddress}:`, data); // Commented out: Data fetching log
                    // --- END LOG ---
                    if (isMounted.current) setProfileData(data);
                })
                .catch(error => {
                    if (isMounted.current) setProfileData(null);
                    // console.error(`[❌ PROFILE_ERROR] fetchProfileData error for ${profileAddress}:`, error); // Commented out: Data fetching error
                })
                .finally(() => {
                    if (isMounted.current) setIsProfileLoading(false);
                });
        } else {
            setProfileData(null);
            setIsProfileLoading(false);
        }
        // Reset data AND original fetched flags when profileAddress changes
        // --- LOG: Resetting Data on Profile Change ---
        // console.log(`[🔄 RESET] Profile address changed to ${profileAddress}. Resetting Deploys, Balances, Trades data and fetch flags.`); // Commented out: Internal state reset log
        // --- END LOG ---
        setFunListData([]);
        setFunBalanceData([]); // Keep this reset if it exists
        setFunBalances([]); // Reset funBalances as well
        setTradeHistory([]);
        setFetched(false); // Reset original flag
        setFetched1(false); // Reset original flag

        return () => {
            isMounted.current = false;
        };
    }, [profileAddress]);
    // --- End Profile Data Effect ---

    useEffect(() => {
        let isMountedLocally = true;
        if (connectedAddress) {
            setIsContactListLoading(true);
            fetchContacts(connectedAddress)
                .then(data => {
                    if (isMountedLocally) setContacts(data);
                })
                .catch(error => {
                    console.error("Error in fetchContacts effect:", error); // Keep: Contact related error
                    if (isMountedLocally) setContacts([]);
                })
                .finally(() => {
                    if (isMountedLocally) setIsContactListLoading(false);
                });
        } else {
            setContacts([]);
            setIsContactListLoading(false);
        }
        return () => { isMountedLocally = false; };
    }, [connectedAddress]);

    useEffect(() => {
        const totalPages = Math.ceil(tradeHistory.length / transactionItemsPerPage);
        setTransactionTotalPages(totalPages);
        if (currentTransactionPage > totalPages && totalPages > 0) {
            setCurrentTransactionPage(1);
        } else if (totalPages === 0) {
            setCurrentTransactionPage(1);
        }
    }, [tradeHistory, currentTransactionPage, transactionItemsPerPage]);

    useEffect(() => {
        let isMountedLocally = true;
        if (connectedAddress) {
            console.log("[Profile] Fetching initial unread counts..."); // Keep: Message related log
            getUnreadMessageCount(connectedAddress, true)
                .then(counts => {
                    if (isMountedLocally && typeof counts === 'object') {
                        console.log("[Profile] Received initial unread counts:", counts); // Keep: Message related log
                        setUnreadCounts(counts);
                    } else if (isMountedLocally) {
                        console.warn("[Profile] Received unexpected format for unread counts:", counts); // Keep: Message related warning
                        setUnreadCounts({});
                    }
                })
                .catch(error => {
                    console.error("[Profile] Failed to fetch initial unread counts:", error); // Keep: Message related error
                    if (isMountedLocally) setUnreadCounts({});
                });
        } else {
            setUnreadCounts({});
        }
        return () => { isMountedLocally = false; };
    }, [connectedAddress]);

    // --- ADD: useEffect to update unreadCounts based on lastMessage ---
    useEffect(() => {
        if (lastMessage && lastMessage.type === 'NEW_MESSAGE' && connectedAddress) {
            const messagePayload = lastMessage.payload;
            const senderAddressLower = messagePayload.senderAddress?.toLowerCase();
            const currentUserAddressLower = connectedAddress.toLowerCase();

            // Check if the message is for the current user and not from the current user
            if (senderAddressLower && messagePayload.receiverAddress?.toLowerCase() === currentUserAddressLower && senderAddressLower !== currentUserAddressLower) {

                // Check if the chat modal with this sender is currently open
                const isChatOpenWithSender = isChatModalOpen && chatTargetUser?.walletAddress.toLowerCase() === senderAddressLower;

                if (!isChatOpenWithSender) {
                    console.log(`[Profile] Received new message from ${senderAddressLower} (chat not open). Incrementing unread count.`);
                    setUnreadCounts(prevCounts => {
                        const currentCount = prevCounts[senderAddressLower] || 0;
                        return {
                            ...prevCounts,
                            [senderAddressLower]: currentCount + 1
                        };
                    });
                    // Note: We don't need to update the global unreadNotificationCount here,
                    // App.jsx handles that based on the same lastMessage.
                } else {
                    console.log(`[Profile] Received new message from ${senderAddressLower}, but chat is already open. Not incrementing count.`);
                    // Optional: If chat is open, immediately mark the message as read in the backend?
                    // markMessagesAsRead(connectedAddress, senderAddressLower); // Be careful about potential race conditions with ChatModal's logic
                }
            }
        }
    }, [lastMessage, connectedAddress, isChatModalOpen, chatTargetUser]); // Add dependencies
    // --- END ADD ---


    // --- MOVED: handleOpenChat definition ---
    const handleOpenChat = useCallback((targetUser: UserProfile | Contact | { walletAddress: string, username: string, profilePicture: string | null }) => {
        console.log("Opening chat with:", targetUser); // Keep: User interaction (opening chat)
        const targetAddressLower = targetUser.walletAddress.toLowerCase();

        // 1. Clear per-sender unread count
        setUnreadCounts(prevCounts => {
            if (prevCounts[targetAddressLower] > 0) {
                console.log(`[Profile] Clearing unread count for ${targetAddressLower}`); // Keep: Message related log
                const newCounts = { ...prevCounts };
                delete newCounts[targetAddressLower]; // Or set to 0
                return newCounts;
            }
            return prevCounts;
        });

        // 2. Mark messages as read in backend
        if (connectedAddress) {
            markMessagesAsRead(connectedAddress, targetAddressLower)
                .catch(err => console.error("Error marking messages as read on chat open:", err)); // Keep: Message related error
        }

        // 3. Mark corresponding notifications in the bell dropdown as read
        onMarkNotificationsRead(targetAddressLower);

        // 4. Set target user and open modal
        const targetUserProfile: UserProfile = {
            walletAddress: targetUser.walletAddress,
            username: targetUser.username || 'User...',
            profilePicture: targetUser.profilePicture || 'profil1.jpg',
        };
        setChatTargetUser(targetUserProfile);
        setIsUserProfileModalOpen(false);
        setIsContactModalOpen(false);
        setIsChatModalOpen(true);
    }, [connectedAddress, onMarkNotificationsRead]); // Dependencies remain the same
    // --- END MOVED ---

    // --- NUEVO useEffect para asegurar Wallet Interna ---
    useEffect(() => {
        const ensureWallet = async () => {
            // --- Add Log ---
            // console.log(`[Profile] ensureWallet effect triggered. isOwnProfile=${isOwnProfile}, connectedAddress=${connectedAddress}`); // Commented out: Internal setup log
            // --- End Log ---
            if (isOwnProfile && connectedAddress) {
                // console.log("[Profile] Ensuring internal wallet exists for owner:", connectedAddress); // Commented out: Internal setup log
                try {
                    const response = await fetch(`${apiUrl}/api/profile/ensure-internal-wallet`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            // Añadir Auth si es necesario (ej: JWT)
                            // 'Authorization': `Bearer ${your_auth_token}`
                        },
                        // --- FIX: Add walletAddress to body for auth middleware ---
                        body: JSON.stringify({
                            walletAddress: connectedAddress
                        })
                        // --- END FIX ---
                    });
                    const result = await response.json();
                    if (!response.ok || !result.success) {
                        // Log the specific error from backend if available
                        // console.warn("[Profile] Failed to ensure internal wallet:", result.error || `HTTP ${response.status}`); // Commented out: Internal setup warning
                        // toast.warn("Could not verify internal wallet setup.");
                    } else {
                        // console.log("[Profile] Internal wallet check/generation successful:", result.message); // Commented out: Internal setup log
                    }
                } catch (error) {
                    // console.error("[Profile] Error calling ensure-internal-wallet endpoint:", error); // Commented out: Internal setup error
                    // toast.error("Error setting up internal wallet.");
                }
            }
        };

        ensureWallet();
    }, [isOwnProfile, connectedAddress, apiUrl]); // Ejecutar cuando cambie isOwnProfile o connectedAddress
    // --- FIN NUEVO useEffect ---

    const handleSelectTab = useCallback((value: string) => setSelectedOption(value), []);

    const handleUsernameUpdate = useCallback((newUsername: string) => {
        setProfileData(prev => prev ? { ...prev, username: newUsername } : null);
    }, []);

    const handlePictureUpdate = useCallback((newPicture: string) => {
        setProfileData(prev => prev ? { ...prev, profilePicture: newPicture } : null);
    }, []);

    const handleAddContact = useCallback(async () => {
        if (!connectedAddress || !profileAddress || isOwnProfile || isAlreadyContact) return;
        setIsContactActionLoading(true);
        // --- ADD LOG ---
        console.log(`[CONTACT] Adding contact. connectedAddress=${connectedAddress}, profileAddress=${profileAddress}`); // Keep: Contact action log
        // --- END ADD ---
        const result = await addContact(connectedAddress, profileAddress);
        if (result.success && profileData) {
            setContacts(prev => [...prev, {
                walletAddress: profileAddress.toLowerCase(),
                username: profileData.username || 'User...',
                profilePicture: profileData.profilePicture || 'profil1.jpg'
            }]);
        } else {
            console.error("Failed to add contact:", result.error); // Keep: Contact action error
        }
        setIsContactActionLoading(false);
    }, [connectedAddress, profileAddress, isOwnProfile, isAlreadyContact, profileData]);

    const handleRemoveContact = useCallback(async (contactAddressToRemove: string) => {
        if (!connectedAddress) return;
        try {
            const result = await removeContact(connectedAddress, contactAddressToRemove);
            if (result.success) {
                setContacts(prev => prev.filter(c => c.walletAddress.toLowerCase() !== contactAddressToRemove.toLowerCase()));
            } else {
                throw new Error(result.error || 'Failed to remove contact');
            }
        } catch (error) {
            console.error("Error removing contact:", error); // Keep: Contact action error
            throw error;
        }
    }, [connectedAddress]);

    const handleKycButtonClick = useCallback((token: { tokenName: string; contractAddress: string }) => {
        setSelectedToken(token);
        setIsKycModalOpen(true);
    }, []);

    const copyAddress = (addr) => async (e) => {
        if (!addr) return;
        try {
            await navigator.clipboard.writeText(addr);
            console.log("Address copied:", addr); // Keep: User interaction (copying address)
        } catch (err) {
            console.error('Failed to copy address: ', err); // Keep: User interaction error
        }
    };
    const referlink = connectedAddress ? `${window.location.origin}/?ref=${connectedAddress}` : `${window.location.origin}/?ref=`;

    const handleUserSelected = useCallback((userData: UserProfile) => {
        console.log("User selected from search:", userData); // Keep: User interaction (selecting user)
        setSelectedUserProfile(userData);
        setIsUserProfileModalOpen(true);
    }, []);

    // --- MODIFIED: handleOpenChat (and similar logic in handleOpenChatWithAddress) ---
    // --- handleOpenChat definition was moved above ---

    const handleAddContactFromModal = useCallback(async (contactToAdd: UserProfile) => {
        if (!connectedAddress || !contactToAdd?.walletAddress) return;
        try {
            const result = await addContact(connectedAddress, contactToAdd.walletAddress);
            if (result.success) {
                fetchContacts(connectedAddress).then(setContacts);
                console.log("Contact added successfully from modal"); // Keep: Contact action log
            } else {
                throw new Error(result.error || 'Failed to add contact');
            }
        } catch (error) {
            console.error("Error adding contact from modal:", error); // Keep: Contact action error
        }
    }, [connectedAddress, fetchContacts]);

    const handleOpenChatFromContactList = useCallback((targetContact: Contact) => {
        console.log("Opening chat with (Contact):", targetContact); // Keep: User interaction (opening chat)
        handleOpenChat(targetContact);
    }, [handleOpenChat]);

    const handleMessagesMarkedRead = useCallback((senderAddr: string) => {
        console.log(`[Profile] Messages marked read for sender: ${senderAddr}. Updating LOCAL unread counts.`); // Keep: Message related log
        setUnreadCounts(prevCounts => ({
            ...prevCounts,
            [senderAddr.toLowerCase()]: 0
        }));
        // No need to call backend markMessagesAsRead here, it's handled when opening chat or via onMarkNotificationsRead
    }, []); // Empty dependency array means this function reference is stable

    const handleChatClose = useCallback(() => {
        console.log("[Profile] Chat modal closed."); // Keep: User interaction (closing chat)
        setIsChatModalOpen(false);
        setChatTargetUser(null);
        // Optionally re-fetch unread counts if needed after closing
        // if (connectedAddress) {
        //     getUnreadMessageCount(connectedAddress, true)
        //         .then(counts => setUnreadCounts(counts))
        //         .catch(error => console.error("Error fetching unread counts after chat close:", error));
        // }
    }, []); // Empty dependency array

    // --- Handlers for Stream Config Modal ---
    // --- Modificar el handler para registrar más información y usar un workaround si es necesario ---
    const handleOpenStreamConfigModal = useCallback(() => {
        console.log(`[Profile] handleOpenStreamConfigModal llamado. isOwnProfile=${isOwnProfile}, connectedAddress=${connectedAddress}, profileAddress=${profileAddress}`);
        
        // Usando una verificación alternativa como respaldo
        const shouldAllowStream = isOwnProfile || 
                                (!profileAddressParam && connectedAddress) ||
                                (connectedAddress && profileAddress && connectedAddress.toLowerCase() === profileAddress.toLowerCase());
        
        if (shouldAllowStream) {
            console.log('[Profile] Abriendo modal de configuración de stream');
            setIsStreamConfigModalOpen(true);
        } else {
            console.warn(`[Profile] No se puede abrir modal: No eres el propietario del perfil. isOwnProfile=${isOwnProfile}`);
            toast.warning("Solo el propietario del perfil puede crear un stream.");
        }
    }, [isOwnProfile, connectedAddress, profileAddress, profileAddressParam]);

    const handleStreamConfigSubmit = useCallback(async (config) => {
        console.log("Stream configuration submitted:", config); // Keep: Stream related log
        setStreamConfigLoading(true);

        try {
            if (config.streamType === 'public') {
                // --- Logic for Public Stream ---
                console.log("Handling PUBLIC stream config..."); // Keep: Stream related log
                // Example: Navigate directly to a generic stream page or generate room name
                const roomName = `${connectedAddress}-${Date.now()}`; // Simple example room ID
                historyHook.push(`/stream/${roomName}`, { // Assuming stream route uses a dynamic ID
                    // Pass necessary info if needed, e.g., chainId if relevant for public
                    ownerAddress: connectedAddress,
                    // streamConfig: config // Pass config if needed by StreamViewPage
                });
                // No backend call needed here *yet* unless you need to register public streams

            } else if (config.streamType === 'solo') {
                // --- Logic for Solo Stream ---
                console.log("Handling SOLO stream config..."); // Keep: Stream related log
                if (!connectedAddress) throw new Error("User not connected.");

                // Call the backend endpoint
                const response = await fetch(`${apiUrl}/api/streams/private/request`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        // 'Authorization': `Bearer ${your_auth_token}` // Add if needed
                    },
                    // --- FIX: Send targetUserAddress as expected by backend ---
                    body: JSON.stringify({
                        walletAddress: connectedAddress, // For authentication (streamer)
                        targetUserAddress: config.targetUserAddress, // The user being invited (payer)
                        entryPriceBNB: parseFloat(config.entryPriceBNB),
                        scheduleInfo: config.scheduleInfo,
                    }),
                    // --- END FIX ---
                });

                // --- FIX: Check response status before parsing JSON ---
                if (!response.ok) {
                    // Attempt to parse error from backend, otherwise use status text
                    let errorMsg = `Failed to create private stream request (HTTP ${response.status} ${response.statusText})`;
                    try {
                        const errorResult = await response.json();
                        if (errorResult && errorResult.error) {
                            errorMsg = errorResult.error;
                        }
                    } catch (parseError) {
                        // Ignore if parsing error response fails
                    }
                    throw new Error(errorMsg);
                }
                // --- END FIX ---

                const result = await response.json(); // Now safe to parse

                // Check for success flag in the parsed result (optional but good practice)
                if (!result.success) {
                     throw new Error(result.error || "Backend indicated failure after successful request.");
                }


                console.log("Private stream request successful:", result); // Keep: Stream related log
                toast.success(`Invite sent to ${config.targetUserAddress.substring(0, 6)}...`); // Keep: Stream related user feedback

            } else {
                throw new Error("Unknown stream type selected.");
            }

            setIsStreamConfigModalOpen(false);

        } catch (error: any) {
            console.error("Error handling stream config submission:", error); // Keep: Stream related error
            toast.error(`Error: ${error.message}`); // Keep: Stream related user feedback
            // Re-throw so the modal can catch it
            throw error;
        } finally {
            setStreamConfigLoading(false);
        }
    }, [connectedAddress, historyHook, apiUrl]);
    // --- End Handlers ---

    // --- NEW: Handler to add contact directly from address ---
    const handleAddContactFromAddress = useCallback(async (addressToAdd: string) => {
        if (!connectedAddress) {
            console.error("Cannot add contact, user not connected."); // Keep: Contact action error
            throw new Error("User not connected"); // Throw error to indicate failure
        }
        console.log(`[Profile] Attempting to add contact: ${addressToAdd}`); // Keep: Contact action log
        try {
            const result = await addContact(connectedAddress, addressToAdd);
            if (result.success) {
                console.log(`[Profile] Contact ${addressToAdd} added successfully. Refreshing contacts...`); // Keep: Contact action log
                // Refresh contacts list after adding
                await fetchContacts(connectedAddress).then(setContacts);
            } else {
                throw new Error(result.error || 'Failed to add contact via service');
            }
        } catch (error) {
            console.error(`[Profile] Error adding contact ${addressToAdd}:`, error); // Keep: Contact action error
            throw error; // Re-throw error so modal can handle UI state
        }
    }, [connectedAddress]); // Dependency: connectedAddress

    // --- NEW: Handler to open chat with an address (fetches profile first) ---
    const handleOpenChatWithAddress = useCallback(async (targetAddress: string) => {
        console.log(`[Profile] Opening chat with address: ${targetAddress}`); // Keep: User interaction (opening chat)
        const targetAddressLower = targetAddress.toLowerCase();

        // 1. Clear per-sender unread count immediately
        setUnreadCounts(prevCounts => {
            if (prevCounts[targetAddressLower] > 0) {
                console.log(`[Profile] Clearing unread count for ${targetAddressLower} (on chat open)`); // Keep: Message related log
                const newCounts = { ...prevCounts };
                delete newCounts[targetAddressLower];
                return newCounts;
            }
            return prevCounts;
        });

        // 2. Mark as read in backend
        if (connectedAddress) {
            markMessagesAsRead(connectedAddress, targetAddressLower)
                .catch(err => console.error("[Profile] Error marking messages as read on chat open (unknown sender):", err)); // Keep: Message related error
        }

        // --- NEW: 3. Mark corresponding notifications in the bell dropdown as read ---
        onMarkNotificationsRead(targetAddressLower);
        // --- END NEW ---

        // 4. Fetch profile and open chat (existing logic)
        try {
            const targetProfile = await fetchProfileData(targetAddress);
            const chatTarget: UserProfile = {
                walletAddress: targetAddress,
                username: targetProfile?.username || `${targetAddress.substring(0, 6)}...`,
                profilePicture: targetProfile?.profilePicture || 'profil1.jpg',
            };
            setChatTargetUser(chatTarget);
            setIsUserProfileModalOpen(false);
            setIsContactModalOpen(false);
            setIsChatModalOpen(true);
        } catch (error) {
            console.error(`[Profile] Failed to fetch profile for ${targetAddress}, opening chat with address only:`, error); // Keep: Message related error (profile fetch failed)
            const chatTarget: UserProfile = {
                walletAddress: targetAddress,
                username: `${targetAddress.substring(0, 6)}...`,
                profilePicture: 'profil1.jpg',
            };
            setChatTargetUser(chatTarget);
            setIsUserProfileModalOpen(false);
            setIsContactModalOpen(false);
            setIsChatModalOpen(true);
        }
    }, [connectedAddress, onMarkNotificationsRead]); // Dependencies: connectedAddress

    // --- NEW: Handlers for Bell Notifications ---
    const handleNotificationClick = useCallback((notification: AppNotification) => {
        console.log("[Profile] Notification clicked:", notification); // Keep: User interaction (notification click)
        // Mark as read
        if (!notification.read) {
            // setNotifications(prev => prev.map(n => n.id === notification.id ? { ...n, read: true } : n)); // This state is lifted, handled in App.jsx
            onNotificationClick(notification); // Call the passed handler
        }

        // Action based on type
        if (notification.type === 'message' && notification.senderAddress) {
            // Open chat with the sender
            handleOpenChatWithAddress(notification.senderAddress);
        } else if (notification.type === 'invite') {
            // TODO: Implement logic to handle invite click (e.g., open payment modal)
            console.log("TODO: Open Payment Modal for invite:", notification.data); // Keep: Stream related log (TODO)
            alert(`Open Payment Modal for Request ID: ${notification.data?.requestId}`); // Keep: Stream related user feedback (placeholder)
        }
        // Add other actions here...

    }, [handleOpenChatWithAddress, onNotificationClick]); // Dependency on chat opening handler and passed handler

    const handleClearAllNotifications = useCallback(() => {
        // Option 1: Mark all as read
        // setNotifications(prev => prev.map(n => ({ ...n, read: true }))); // This state is lifted, handled in App.jsx
        onClearAllNotifications(); // Call the passed handler
        // Option 2: Remove all notifications
        // setNotifications([]);
    }, [onClearAllNotifications]); // Dependency on passed handler
    // --- END NEW Handlers ---

    // --- NEW: useEffect to handle opening chat from navigation state ---
    useEffect(() => {
        const addressToOpen = location.state?.senderAddressToOpenChat;
        if (addressToOpen) {
            console.log(`[Profile] Found senderAddressToOpenChat in location state: ${addressToOpen}. Opening chat...`); // Keep: Message related log (opening from nav)
            // Call the existing handler to open the chat
            handleOpenChatWithAddress(addressToOpen);

            // Clear the state from history so it doesn't re-trigger on refresh/back
            historyHook.replace({ ...location, state: undefined });
        }
    }, [location.state, handleOpenChatWithAddress, historyHook]); // Dependencies
    // --- END NEW ---

    // --- ADD LOG: Before Return ---
    // console.log(`[Profile] Reaching end of render function. isProfileLoading=${isProfileLoading}, profileData=`, profileData); // Commented out: General render log
    // --- END LOG ---

    // Add state for new features
   // const [internalWallet, setInternalWallet] = useState<InternalWalletInfo | null>(null);
  //  const [privateStreams, setPrivateStreams] = useState<PrivateStreamInfo[]>([]);
    //const [withdrawAmount, setWithdrawAmount] = useState('');
    //const [isWithdrawModalOpen, setIsWithdrawModalOpen] = useState(false);
    //const [isProcessingWithdrawal, setIsProcessingWithdrawal] = useState(false);
    //const [withdrawError, setWithdrawError] = useState('');

    // Add useEffect to fetch internal wallet info and private streams
    const fetchWalletAndStreams = useCallback(async () => {
        if (!profileAddress) return;
        
        try {
          console.log(`[Profile] Fetching wallet and streams for ${profileAddress}`);
          
          // Use the correctly named function
          const walletInfo = await getInternalWalletBalance(profileAddress);
          setInternalWallet(walletInfo);
          setWalletInfo(walletInfo);
          console.log(`[Profile] Successfully fetched wallet info:`, walletInfo);
          
          // Create an array to hold all streams
          let allStreams: PrivateStreamInfo[] = [];
          
          try {
            // First try with the combined endpoint that should return both roles
            console.log(`[Profile] Attempting to fetch ALL streams (both roles) for ${profileAddress}`);
            const streams = await chatService.fetchAllUserStreams(profileAddress);
            
            if (streams.length > 0) {
              console.log(`[Profile] Successfully fetched ${streams.length} streams (all types)`);
              
              // Log specific stream types for debugging
              const pendingStreams = streams.filter(s => s.status === 'pending');
              const paidStreams = streams.filter(s => s.status === 'paid');
              const activeStreams = streams.filter(s => s.status === 'active');
              
              console.log(`[Profile] Stream breakdown: ${pendingStreams.length} pending, ${paidStreams.length} paid, ${activeStreams.length} active`);
              
              setPrivateStreams(streams);
            } else {
              setPrivateStreams([]);
              console.log(`[Profile] No streams found for this user`);
            }
          } catch (streamsError) {
            console.error("[Profile] Error fetching private streams:", streamsError);
            // Don't fail the whole function if streams fail but wallet succeeds
          }
        } catch (error) {
          console.error("[Profile] Error fetching wallet info or private streams:", error);
        }
      }, [profileAddress]);
      
      useEffect(() => {
        fetchWalletAndStreams();
        // --- NEW: Fetch withdrawal history when profileAddress changes or page changes ---
        if (profileAddress && isOwnProfile) { // Only fetch for own profile for now, can be adjusted
            setIsLoadingWithdrawalHistory(true);
            fetchWithdrawalHistory(profileAddress, currentWithdrawalHistoryPage)
                .then(data => {
                    setWithdrawalHistory(data.data);
                    setWithdrawalHistoryPagination(data.pagination);
                })
                .catch(error => {
                    console.error("[Profile] Error fetching withdrawal history:", error);
                    setWithdrawalHistory([]);
                    setWithdrawalHistoryPagination(null);
                    // Optionally show a toast error
                })
                .finally(() => {
                    setIsLoadingWithdrawalHistory(false);
                });
        }
        // --- END NEW ---
      }, [fetchWalletAndStreams, profileAddress, isOwnProfile, currentWithdrawalHistoryPage]); // Added dependencies

    // Add withdraw handler
    const handleWithdraw = async () => {
        if (!profileAddress || !withdrawAmount || parseFloat(withdrawAmount) <= 0) {
            setWithdrawError('Please enter a valid amount');
            return;
        }
        
        try {
            setIsProcessingWithdrawal(true);
            setWithdrawError('');
            
            const result = await withdrawFromInternalWallet(profileAddress, withdrawAmount);
            
            if (result.success) {
                toast.success('Withdrawal initiated successfully');
                setIsWithdrawModalOpen(false);
                // Refresh wallet info
                const updatedWalletInfo = await getInternalWalletBalance(profileAddress);
                setInternalWallet(updatedWalletInfo);
                // --- NEW: Refresh withdrawal history after a successful withdrawal ---
                if (profileAddress && isOwnProfile) {
                    fetchWithdrawalHistory(profileAddress, 1) // Fetch first page
                        .then(data => {
                            setWithdrawalHistory(data.data);
                            setWithdrawalHistoryPagination(data.pagination);
                            setCurrentWithdrawalHistoryPage(1); // Reset to page 1
                        })
                        .catch(error => console.error("[Profile] Error refreshing withdrawal history:", error));
                }
                // --- END NEW ---
            } else {
                setWithdrawError(result.message || 'Withdrawal failed');
            }
        } catch (error: any) {
            setWithdrawError(error.message || 'Failed to process withdrawal');
        } finally {
            setIsProcessingWithdrawal(false);
        }
    };

    // Add countdown formatter
    const formatTimeRemaining = (dateString: string) => {
        const targetDate = new Date(dateString);
        const now = new Date();
        const diffMs = targetDate.getTime() - now.getTime();
        
        if (diffMs <= 0) return 'Starting soon';
        
        const diffHrs = Math.floor(diffMs / 3600000);
        const diffMins = Math.floor((diffMs % 3600000) / 60000);
        const diffSecs = Math.floor((diffMs % 60000) / 1000);
        
        return `${diffHrs.toString().padStart(2, '0')}:${diffMins.toString().padStart(2, '0')}:${diffSecs.toString().padStart(2, '0')}`;
    };

    // Add a timer refresh effect for countdowns
    useEffect(() => {
        // Only set up timer if we have streams
        if (privateStreams.length === 0) return;
        
        const timer = setInterval(() => {
            // This will trigger a re-render to update countdowns
            setPrivateStreams(prev => [...prev]);
        }, 1000);
        
        return () => clearInterval(timer);
    }, [privateStreams.length]);

    // Modify the wallet fetching function to handle errors better
    const fetchWalletBalance = useCallback(async () => {
        if (!profileAddress) return;
        
        try {
          setIsLoadingWallet(true);
          console.log(`[Profile] Fetching wallet balance for ${profileAddress}`);
          const walletInfo = await fetchInternalWalletInfo(profileAddress);
          setInternalWallet(walletInfo);
          console.log(`[Profile] Successfully fetched wallet info:`, walletInfo);
        } catch (error) {
          console.error("[Profile] Error fetching wallet balance:", error);
          
          // Still show the wallet UI with a retry option
          // Create a placeholder wallet info with zero balance
          if (!internalWallet) {
            setInternalWallet({
              success: false,
              address: "0x0000000000000000000000000000000000000000", // Placeholder
              balance: "0.0000",
              error: "Failed to load balance"
            });
          }
          
          toast.error('Failed to load wallet information. Try refreshing.');
        } finally {
          setIsLoadingWallet(false);
        }
      }, [profileAddress, internalWallet]);

    //const [walletInfo, setWalletInfo] = useState<any>(null);

    // Agregar efecto para actualizar el estado de los streams cada segundo
    useEffect(() => {
        // Solo configurar el temporizador si hay streams
        if (privateStreams.length === 0) return;
        
        // Timer para actualizar la UI cada segundo (para los temporizadores)
        const timer = setInterval(() => {
            // Esto forzará un re-render para actualizar los temporizadores
            if (isMounted.current) setPrivateStreams(prev => [...prev]);
        }, 1000);
        
        return () => clearInterval(timer);
    }, [privateStreams.length]);

    // Manejador para iniciar un stream
    const handleStartStream = useCallback(async (streamId) => {
        if (!connectedAddress) {
            toast.error("No estás conectado. Por favor, conecta tu wallet.");
            return;
        }
        
        console.log(`[Profile] Iniciando stream: ${streamId}`);
        
        try {
            // Aquí implementarías la llamada a la API para cambiar el estado del stream a 'active'
            // Por ejemplo:
            // const response = await fetch(`${apiUrl}/api/streams/private/request/${streamId}/start`, {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify({ walletAddress: connectedAddress })
            // });
            
            // if (!response.ok) throw new Error('Error al iniciar el stream');
            
            // Actualizar el estado local
            setPrivateStreams(prev => prev.map(stream => 
                stream._id === streamId 
                    ? { ...stream, status: 'active' } 
                    : stream
            ));
            
            toast.success("¡Stream iniciado con éxito!");
            
            // Aquí podrías redirigir al usuario a la página del stream
            // history.push(`/stream/${streamId}`);
            
        } catch (error) {
            console.error("[Profile] Error al iniciar stream:", error);
            toast.error("Error al iniciar el stream. Inténtalo de nuevo.");
        }
    }, [connectedAddress]);

    // Move getStreamStartTime function definition above activeStreams useMemo to fix TDZ error
    const getStreamStartTime = (stream) => {
        if (stream.status !== 'paid') return new Date(); // Default to now for non-paid streams
        
        const updatedTime = new Date(stream.updatedAt);
        const scheduleMatch = stream.scheduleInfo?.match(/(\d+)\s*([a-zA-Z]+)/);
        
        if (!scheduleMatch) return updatedTime;
        
        const [_, value, unit] = scheduleMatch;
        const numValue = parseInt(value, 10);
        
        const resultTime = new Date(updatedTime);
        
        switch (unit.toLowerCase()) {
          case 'hour':
          case 'hours':
            resultTime.setHours(resultTime.getHours() + numValue);
            break;
          case 'minute':
          case 'minutes':
            resultTime.setMinutes(resultTime.getMinutes() + numValue);
            break;
          case 'day':
          case 'days':
            resultTime.setDate(resultTime.getDate() + numValue);
            break;
          default:
            resultTime.setHours(resultTime.getHours() + 1);
        }
        
        return resultTime;
    };

    // Redefine activeStreams to process streams and add streamStartTime
    const activeStreams = useMemo(() => {
        // Ensure we have streams to process
        if (!privateStreams || privateStreams.length === 0) {
          console.log('[Profile] No private streams to process for active stream display');
          return [];
        }
        
        console.log(`[Profile] Processing ${privateStreams.length} streams for active display:`, 
          privateStreams.map(s => ({
            id: s._id,
            streamer: s.streamerAddress?.substring(0, 6),
            invited: s.invitedAddress?.substring(0, 6),
            status: s.status
          }))
        );
        
        return privateStreams
          // Include both paid and active streams
          .filter(stream => stream.status === 'paid' || stream.status === 'active')
          // Add calculated streamStartTime property
          .map(stream => {
            const calculatedTime = getStreamStartTime(stream);
            console.log(`[Profile] Stream ${stream._id} start time calculated as: ${calculatedTime}`);
            return {
              ...stream,
              streamStartTime: calculatedTime
            };
          })
          .slice(0, 3); // Show up to 3 streams
      }, [privateStreams]);

    // Process all relevant streams for display - this now includes pending invites
    const processedStreams = useMemo(() => {
        // Ensure we have streams to process
        if (!privateStreams || privateStreams.length === 0) {
          console.log('[Profile] No private streams to process for display');
          return [];
        }
        
        console.log(`[Profile] Processing ${privateStreams.length} streams for display`);
        
        // Process all streams with our utility function
        return privateStreams.map(stream => processStreamForDisplay(stream, profileAddress))
          .sort((a, b) => {
            // Pending invites come first
            if (a.status === 'pending' && b.status !== 'pending') return -1;
            if (b.status === 'pending' && a.status !== 'pending') return 1;
            
            // Then paid streams (waiting to start)
            if (a.status === 'paid' && b.status !== 'paid') return -1;
            if (b.status === 'paid' && a.status !== 'paid') return 1;
            
            // Active streams last within the first 5 items
            if (a.status === 'active' && b.status !== 'active') return -1;
            if (b.status === 'active' && a.status !== 'active') return 1;
            
            // Sort by most recent for the same type
            return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
          })
          .slice(0, 5); // Show up to 5 most relevant streams
      }, [privateStreams, profileAddress]);

    const handlePayForStream = useCallback((stream) => {
        console.log("Opening payment modal for stream:", stream);
        setSelectedStream(stream);
        setIsPaymentModalOpen(true);
    }, []);

    // Handle payment success from the modal
    const handlePaymentSuccess = useCallback(async (txHash, requestId) => {
        console.log(`Payment success! Hash: ${txHash}, RequestID: ${requestId}`);
        
        try {
            // Call the backend to confirm payment
            const result = await chatService.confirmPayment(requestId, txHash);
            
            if (result.success) {
                toast.success("Payment confirmed! Stream status updated.");
                
                // Close the modal
                setIsPaymentModalOpen(false);
                setSelectedStream(null);
                
                // Refresh wallet and streams data
                fetchWalletAndStreams();
            } else {
                toast.error(result.message || "Failed to confirm payment on server");
            }
        } catch (error) {
            console.error("Error confirming payment:", error);
            toast.error(error.message || "Error confirming payment");
        }
    }, [fetchWalletAndStreams]);

    // Handle rejection from the modal
    const handleRejectSuccess = useCallback(async (requestId) => {
        console.log(`Rejecting invite ID: ${requestId}`);
        
        try {
            const result = await chatService.rejectInvite(requestId);
            
            if (result.success) {
                toast.success("Invitation rejected successfully");
                
                // Close the modal
                setIsPaymentModalOpen(false);
                setSelectedStream(null);
                
                // Refresh streams data
                fetchWalletAndStreams();
            } else {
                toast.error(result.message || "Failed to reject invitation");
            }
        } catch (error) {
            console.error("Error rejecting invitation:", error);
            toast.error(error.message || "Error rejecting invitation");
        }
    }, [fetchWalletAndStreams]);

    return (
        <div className="GlobalContainer">
            <div style={{ zIndex: 1 }}>
                
                <div className='px-4 pt-4 pb-24 m-auto max-w-7xl sm:pt-4 sm:px-12'>

                    <ProfileHeader
                        profileAddress={profileAddress}
                        connectedAddress={connectedAddress}
                        profileUsername={profileData?.username ?? null}
                        profilePicture={profileData?.profilePicture ?? 'profil1.jpg'}
                        isProfileLoading={isProfileLoading}
                        isContactLoading={isContactActionLoading}
                        isAlreadyContact={isAlreadyContact}
                        isOwnProfile={isOwnProfile}
                        onOpenContactModal={() => setIsContactModalOpen(true)}
                        onOpenUsernameModal={() => setIsUsernameModalOpen(true)}
                        onOpenPictureModal={() => setIsPictureModalOpen(true)}
                        onAddContact={handleAddContact}
                        onSendMessage={() => handleOpenChat(profileData)}
                        onOpenStreamConfigModal={handleOpenStreamConfigModal} // Pass the new handler
                        totalUnreadCount={totalUnreadCount}
                        internalWallet={internalWallet} // Pass the internal wallet info
                        privateStreams={privateStreams} // Pass the private streams
                        formatTimeRemaining={formatTimeRemaining} // Pass the countdown formatter
                        onWithdraw={() => setIsWithdrawModalOpen(true)} // Pass the withdraw handler
                        walletInfo={walletInfo} // Pasar la información de la wallet al ProfileHeader
                        onStartStream={handleStartStream} // Agregar el prop para iniciar streams
                        activeStreams={activeStreams} // Pasar los streams procesados
                        processedStreams={processedStreams} // Pass the processed streams
                        onPayForStream={handlePayForStream} // Pass the payment handler
                    />

                    <div className='flex flex-col gap-6 md:flex-row'>
                        <ProfileTabs
                            selectedOption={selectedOption}
                            handleSelect={handleSelectTab}
                            // --- FIX: Pass formatted balances ---
                            funBalances={formattedFunBalances} // Pass the formatted data
                            // --- END FIX ---
                            tradeHistory={tradeHistory} // <-- FIX: Pass tradeHistory state here
                            funLists={funLists}
                            loading={loading} // Pass single loading state
                            // Remove specific loading props
                            // loadingBalances={loadingBalances}
                            // loadingTrades={loadingTrades}
                            // loadingDeploys={loadingDeploys}
                            currentTransactionPage={currentTransactionPage}
                            transactionTotalPages={transactionTotalPages}
                            transactionItemsPerPage={transactionItemsPerPage}
                            setCurrentTransactionPage={setCurrentTransactionPage}
                            isOwnProfile={isOwnProfile}
                            onKycButtonClick={handleKycButtonClick}
                        />

                        <div className={`h-fit flex-col p-6 w-full md:w-[360px] bg-[#6d79ad33] rounded-[10px] lg: px-8 px-2.5 py-5 backdrop-blur-[8px] border-2 border-[#ffffff66]`}>
                            <div className="token-info-item">
                                <span className="mx-auto token-info-label">
                                    <h3 className='text-white font-bold text-[24px]' style={{ marginTop: '0px' }}>
                                        Earn <span className='text-[#7db4e5]'>0.5%</span> of each trade
                                    </h3>
                                </span>
                            </div>
                            <div className="mt-2 token-info-item">
                                <span className="font-light text-gray-300 token-info-label">
                                    Share referral link with your friends and earn 0.5% of every trade they make.
                                </span>
                            </div>
                            <br />
                            <div className='bg-[#010101] flex w-full items-center gap-2 rounded-[8px] py-[14px] pr-[8px] pl-[16px]'>
                                <span className='text-[16px] text-white font-semibold w-full truncate'>{referlink}</span>
                                <button className='flex justify-center items-center w-12 h-12 rounded-[8px] bg-[#283c60] hover:bg-[#4a5e82] flex-shrink-0' onClick={copyAddress(referlink)}>
                                    <img src={CopyIcon} alt="Copy referral link" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <KycModal
                isOpen={isKycModalOpen}
                onClose={() => setIsKycModalOpen(false)}
                initialData={selectedToken}
            />
            {isOwnProfile && connectedAddress && (
                <>
                    <UsernameModal
                        isOpen={isUsernameModalOpen}
                        onClose={() => setIsUsernameModalOpen(false)}
                        currentUsername={profileData?.username || ''}
                        walletAddress={connectedAddress}
                        onUsernameUpdate={handleUsernameUpdate}
                    />
                    <ProfilePictureModal
                        isOpen={isPictureModalOpen}
                        onClose={() => setIsPictureModalOpen(false)}
                        currentPicture={profileData?.profilePicture || 'profil1.jpg'}
                        walletAddress={connectedAddress}
                        onPictureUpdate={handlePictureUpdate}
                    />
                </>
            )}
            <ContactListModal
                isOpen={isContactModalOpen}
                onClose={() => setIsContactModalOpen(false)}
                contacts={contacts}
                onRemoveContact={handleRemoveContact}
                onSendMessage={handleOpenChatFromContactList} // Keep for existing contacts
                isLoading={isContactListLoading}
                unreadCounts={unreadCounts || {}}
                onAddContactFromAddress={handleAddContactFromAddress} // Pass new handler
                onOpenChatWithAddress={handleOpenChatWithAddress} // Pass new handler
            />

            {selectedUserProfile && (
                <UserProfileModal
                    isOpen={isUserProfileModalOpen}
                    onClose={() => setIsUserProfileModalOpen(false)}
                    userProfile={selectedUserProfile}
                    currentUserAddress={connectedAddress}
                    onAddContact={handleAddContactFromModal}
                    onSendMessage={handleOpenChat}
                    isContact={(addr) => contacts.some(c => c.walletAddress.toLowerCase() === addr.toLowerCase())}
                />
            )}

            {isChatModalOpen && chatTargetUser && connectedAddress && (
                <ChatModal
                    isOpen={isChatModalOpen}
                    onClose={handleChatClose} // Use the stable callback
                    targetUser={chatTargetUser}
                    currentUserAddress={connectedAddress}
                    lastMessage={lastMessage}
                    onChatClose={handleChatClose} // Use the stable callback
                    onMessagesMarkedRead={handleMessagesMarkedRead} // Use the stable callback
                    isConnected={isWsConnected} // Pass the prop received from App.jsx
                    sendMessage={sendWsMessage} // Pass the prop received from App.jsx
                />
            )}

            {/* Render the new Stream Config Modal */}
            {isOwnProfile && (
                 <StreamConfigModal
                    isOpen={isStreamConfigModalOpen}
                    onClose={() => setIsStreamConfigModalOpen(false)}
                    onSubmit={handleStreamConfigSubmit}
                    isLoading={streamConfigLoading}
                 />
            )}

            {/* Withdraw Modal */}
            {isWithdrawModalOpen && internalWallet && (
                <div className="modal-overlay">
                    <div className="withdraw-modal">
                        <h3>Withdraw Funds</h3>
                        <p>Available Balance: {parseFloat(internalWallet.balance).toFixed(4)} {internalWallet.symbol || 'BNB'}</p> {/* Added symbol */}
                        
                        <div className="input-group">
                            <label htmlFor="withdrawAmountInput">Amount to Withdraw ({internalWallet.symbol || 'BNB'})</label> {/* Added symbol and htmlFor */}
                            <input
                                id="withdrawAmountInput" // Added id
                                type="number"
                                value={withdrawAmount}
                                onChange={(e) => setWithdrawAmount(e.target.value)}
                                placeholder={`E.g., 0.1 ${internalWallet.symbol || 'BNB'}`} // Added placeholder
                                step="any" // Allow any decimal step
                                min="0.00000001" // Smallest possible unit
                                max={internalWallet.balance}
                                disabled={isProcessingWithdrawal}
                            />
                        </div>

                        {/* Percentage Buttons */}
                        <div className="percentage-buttons">
                            {[0.25, 0.50, 0.75, 1.00].map((percentage) => {
                                const amount = parseFloat(internalWallet.balance) * percentage;
                                // Ensure the amount has a reasonable number of decimal places and is a string
                                const displayAmount = parseFloat(amount.toFixed(8)); // Limit to 8 decimal places for display/setting

                                return (
                                    <button
                                        key={percentage}
                                        className="percentage-button"
                                        onClick={() => setWithdrawAmount(String(displayAmount))}
                                        disabled={isProcessingWithdrawal || parseFloat(internalWallet.balance) <= 0}
                                    >
                                        {percentage * 100}%
                                    </button>
                                );
                            })}
                        </div>
                        
                        {withdrawError && <p className="error-message">{withdrawError}</p>}
                        
                        <div className="modal-buttons">
                            <button
                                className="cancel-button"
                                onClick={() => setIsWithdrawModalOpen(false)}
                                disabled={isProcessingWithdrawal}
                            >
                                Cancel
                            </button>
                            <button
                                className="confirm-button"
                                onClick={handleWithdraw}
                                disabled={
                                    isProcessingWithdrawal ||
                                    !withdrawAmount ||
                                    parseFloat(withdrawAmount) <= 0 ||
                                    parseFloat(withdrawAmount) > parseFloat(internalWallet.balance)
                                }
                            >
                                {isProcessingWithdrawal ? 'Processing...' : 'Confirm Withdraw'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Section to Display Withdrawal History */}
            {isOwnProfile && (
                <div className="withdrawal-history-section">
                    <h4>Withdrawal History</h4>
                    {isLoadingWithdrawalHistory ? (
                        <p>Loading withdrawal history...</p>
                    ) : withdrawalHistory.length > 0 ? (
                        <>
                            <table className="withdrawal-history-table">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Amount</th>
                                        <th>Symbol</th>
                                        <th>Status</th>
                                        <th>TX Hash</th>
                                        <th>To Address</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {withdrawalHistory.map(record => (
                                        <tr key={record._id}>
                                            <td>{new Date(record.timestamp).toLocaleString()}</td>
                                            <td>{record.amount.toFixed(6)}</td>
                                            <td>{record.symbol}</td>
                                            <td>
                                                <span className={`status-badge status-${record.status.toLowerCase()}`}>
                                                    {record.status}
                                                </span>
                                            </td>
                                            <td>
                                                {record.transactionHash ? (
                                                    <a 
                                                        href={record.blockchainNetwork && scanLinks[record.blockchainNetwork] ? `${scanLinks[record.blockchainNetwork]}/tx/${record.transactionHash}` : '#'}
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        title={record.transactionHash}
                                                    >
                                                        {`${record.transactionHash.substring(0, 6)}...${record.transactionHash.substring(record.transactionHash.length - 4)}`}
                                                    </a>
                                                ) : 'N/A'}
                                            </td>
                                            <td title={record.withdrawalAddress}>{`${record.withdrawalAddress.substring(0, 6)}...${record.withdrawalAddress.substring(record.withdrawalAddress.length - 4)}`}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* Pagination Controls */}
                            {withdrawalHistoryPagination && withdrawalHistoryPagination.totalPages > 1 && (
                                <div className="pagination-controls">
                                    <button 
                                        onClick={() => setCurrentWithdrawalHistoryPage(prev => Math.max(1, prev - 1))}
                                        disabled={currentWithdrawalHistoryPage === 1 || isLoadingWithdrawalHistory}
                                    >
                                        Previous
                                    </button>
                                    <span>Page {currentWithdrawalHistoryPage} of {withdrawalHistoryPagination.totalPages}</span>
                                    <button 
                                        onClick={() => setCurrentWithdrawalHistoryPage(prev => Math.min(withdrawalHistoryPagination.totalPages, prev + 1))}
                                        disabled={currentWithdrawalHistoryPage === withdrawalHistoryPagination.totalPages || isLoadingWithdrawalHistory}
                                    >
                                        Next
                                    </button>
                                </div>
                            )}
                        </>
                    ) : (
                        <p>No withdrawal history found.</p>
                    )}
                </div>
            )}

            {/* Add the payment modal */}
            <PrivateStreamPaymentModal
                isOpen={isPaymentModalOpen}
                onClose={() => setIsPaymentModalOpen(false)}
                requestDetails={selectedStream ? {
                    _id: selectedStream._id,
                    requestId: selectedStream._id, // Ensure requestId is set
                    streamerAddress: selectedStream.streamerAddress,
                    invitedAddress: selectedStream.invitedAddress,
                    entryPriceBNB: selectedStream.entryPriceBNB,
                    scheduleInfo: selectedStream.scheduleInfo,
                    status: selectedStream.status,
                    streamerInternalWallet: selectedStream.streamerAddress, // Use streamer address as the recipient
                    createdAt: selectedStream.createdAt,
                    streamerUsername: selectedStream.streamerUsername,
                    streamerProfilePicture: selectedStream.streamerProfilePicture
                } : null}
                onPaymentSuccess={handlePaymentSuccess}
                onRejectSuccess={handleRejectSuccess}
            />
        </div >
    );
}

export default Profile;